/* eslint-disable react/jsx-no-undef */
import React from "react";
import { useNavigate } from "react-router-dom";
import TopLogo from '../../components/layout/TopLogo';
import dayjs from "dayjs";
import coupon2 from '../../assets/images/coupon2.png';
import SecondaryButton from "../../components/button/SecondaryButton";
import PrimaryButton from "../../components/button/PrimaryButton";
import Stack from "@mui/material/Stack";
import { useDispatch, useSelector } from 'react-redux';
import { SearchCouponById, UpdateCoupon, DeleteCoupon } from "../../services/Coupon";
import { setShop } from "../../features/ShopSlice";
import CustomPopup from "../../components/popup/CustomPopup";
import CloseIcon from '@mui/icons-material/Close';
import { Dialog } from "@mui/material";
import helper from "../../functions/helper";

export default function ShopCouponDetail() {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const store = useSelector((state) => state.shop)
    const [page, setPage] = React.useState("info");
    const [couponDetail, setCouponDetail] = React.useState({});
    const [loading, setLoading] = React.useState(false);
    const now = new Date()

    const [openConfirmPopup, setOpenConfirmPopup] = React.useState(false);
    const [openCancelPopup, setOpenCancelPopup] = React.useState(false);
    const [openDeletePopup, setOpenDeletePopup] = React.useState(false);


    React.useEffect(() => {
        getSearchCouponById()
    }, []);

    async function getSearchCouponById() {
        return await SearchCouponById(store['couponId'])
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    let data = response.data.body
                    data.widthBlue = data.usedAmount / data.amount * 100
                    data.widthGray = ((data.amount - data.usedAmount) / data.amount * 100) + 1
                    data.diffStart = dayjs(now).diff(data.startDate)
                    data.diffExpire = dayjs(data.expireDate).hour(23).minute(59).second(59).diff(now)
                    if (data.discountType === 'Fix') {
                        data.discountText = `฿${helper.numberWithCommas(data.discount)} | ขั้นต่ำ ฿${helper.numberWithCommas(data.min)}`
                    } else {
                        data.discountText = `${helper.numberWithCommas(data.discount)}% | ขั้นต่ำ ฿${helper.numberWithCommas(data.min)}`
                    }
                    setCouponDetail(data)
                    setLoading(true)

                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    async function postUpdateCoupon() {
        if (store['owner']) {
            return await UpdateCoupon({ data: { couponId: store['couponId'], shopId: store['shopId'] } })
                .then(async (response) => {
                    if (+response.data.resultCode === 20000) {
                        navigate("/shop-coupon")
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            postDeleteCoupon()
        }
    }

    async function postDeleteCoupon() {
        return await DeleteCoupon({ data: { couponId: store['couponId'], shopId: store['shopId'] } })
            .then(async (response) => {
                if (+response.data.resultCode === 20000) {
                    navigate("/shop-coupon")
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }


    function fnSetData(name, value) {
        const tmpObj = {};
        tmpObj[name] = value;
        dispatch(setShop(tmpObj));
    }

    return (
        <>
            <TopLogo />
            {couponDetail &&
                <div
                    style={{
                        background: "#005AAA",
                        paddingTop: "20px"
                    }}
                >
                    <div className="text-white text-center text-[20px] mb-[15px]">
                        {couponDetail.shopName}
                    </div>

                    <div className="overflow-y-auto px-[20px]" style={{ height: "calc(100vh - 250px)" }}>
                        {/* <InfiniteScroll
                        loadMore={fetchItems}
                        hasMore={isLoading}
                        loader={loader}
                    > */}
                        <div id="section1" className="px-[10px] py-[15px] bg-lightGray2 mb-[20px] rounded-[6px]">

                            <div className="text-center">
                                <p className="text-blue text-[24px]">{couponDetail.name}</p>
                                <p className="text-darkGray text-[20px]">ส่วนลด {couponDetail.discountText}</p>
                                <p className="text-darkGray text-[20px] leading-[16px]">วันที่เริ่มต้นใช้คูปอง {dayjs(couponDetail.startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {dayjs(couponDetail.expireDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</p>
                            </div>

                            <hr className="border-b-1px border-lightGray w-full mt-[10px] mb-[20px]" />

                            <div className="flex mx-[20px]">
                                <p className="font-bole text-[16px]">จำนวนคูปอง</p>
                                <div className="flex ml-auto mr-[0px] w-fit">
                                    <p className="text-lightBlue text-[16px]">{couponDetail.usedAmount}</p>
                                    <p className="text-gray text-[16px]">/{couponDetail.amount}</p>
                                </div>
                            </div>
                            <div className="flex mx-[20px]">
                                <div className="gradient-line h-14[px]" style={{ width: `${couponDetail.widthBlue}%`, zIndex: "999" }}></div>
                                <div className="gray-line2 h-[14px] ml-[-2px]" style={{ width: `${couponDetail.widthGray}%`, height: "14px !important" }}> </div>
                            </div>

                            {couponDetail.picture ? (
                                <img
                                    className="mx-auto mt-[10px]"
                                    src={couponDetail.picture}
                                    alt="logo"
                                    style={{ width: "208px" }}
                                />
                            ) : (
                                <img
                                    className="mx-auto mt-[10px]"
                                    src={coupon2}
                                    alt="logo"
                                    style={{ width: "208px" }}
                                />
                            )
                            }

                            <div className="items-center text-center mt-[20px]">
                                {(couponDetail.diffStart >= 0 && couponDetail.diffExpire >= 0 && couponDetail.status === 'Active') ?
                                    (<div className="w-[114px] h-[40px] pt-[5px] mx-auto" style={{ borderRadius: '28px', background: 'linear-gradient(90deg, rgba(0, 185, 241, 1) 0%, rgba(0, 90, 170, 1) 100%' }}>
                                        <p className="text-white text-[20px]">กำลังใช้งาน</p>
                                    </div>
                                    ) : (couponDetail.diffStart >= 0 && couponDetail.diffExpire >= 0 && couponDetail.status === 'Inactive') ? (
                                        <div className="w-[114px] h-[40px] pt-[5px] mx-auto" style={{ borderRadius: '28px', background: 'rgba(109, 110, 113, 1)' }}>
                                            <p className="text-white text-[20px]">ยังไม่ได้เปิดใช้งาน</p>
                                        </div>
                                    ) : (couponDetail.diffExpire < 0) ? (
                                        <div className="w-[114px] h-[40px] pt-[5px] mx-auto" style={{ borderRadius: '28px', background: 'linear-gradient(90deg, rgba(230, 231, 232, 0.8) 0%, rgba(109, 110, 113, 0.8) 100%)' }}>
                                            <p className="text-white text-[20px]">หมดอายุ</p>
                                        </div>
                                    ) : (
                                        <div className="w-[114px] h-[40px] pt-[5px] mx-auto" style={{ borderRadius: '28px', background: 'rgba(7, 24, 34, 1)' }}>
                                            <p className="text-white text-[20px]">เตรียมใช้งาน</p>
                                        </div>
                                    )
                                }

                            </div>

                            <div className="flex items-center">
                                <p
                                    onClick={() => setPage("info")}
                                    className={
                                        `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                                        (page === "info" && "!text-blue !border-b-[4px] !border-blue")
                                    }
                                >  รายละเอียด
                                </p>
                                <p
                                    onClick={() => setPage("condition")}
                                    className={
                                        `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                                        (page === "condition" &&
                                            "!text-blue !border-b-[4px] !border-blue")
                                    }
                                >
                                    เงื่อนไข
                                </p>
                                <p
                                    onClick={() => setPage("branch")}
                                    className={
                                        `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                                        (page === "branch" &&
                                            "!text-blue !border-b-[4px] !border-blue")
                                    }
                                >
                                    สาขาที่ร่วม
                                </p>
                            </div>

                            {page === "info" ? (
                                <div className="whitespace-pre-line mx-[15px] mt-[20px]">
                                    {couponDetail.detail}
                                </div>
                            ) : page === "condition" ? (
                                <div className="whitespace-pre-line mx-[15px] mt-[20px]">
                                    {couponDetail.conditions}
                                </div>
                            ) : (
                                <div className="mx-[15px] mt-[20px]">
                                    {Array.isArray(couponDetail.participatingList) && couponDetail.participatingList.length > 0 && couponDetail.participatingList.map((item, index) => (
                                        <div key={index}>
                                            <p>- {item}</p>
                                        </div>
                                    ))}
                                </div>
                            )}


                            {/* {couponDetail.diffExpire < 0 && */}

                            {/* } */}
                            {(couponDetail.diffStart < 0 && couponDetail.diffExpire >= 0 && loading) &&

                                <button
                                    onClick={() => {
                                        setOpenDeletePopup(true)
                                    }}
                                    className="my-[20px] w-fit flex gap-[5px] items-center justify-center py-[1px] px-[10px] rounded-[5px] border-[1px] border-red"
                                >
                                    <CloseIcon sx={{
                                        color: "#FF2B1E",
                                        width: "15px"
                                    }} />
                                    <p className="text-red text-[20px]">ลบคูปอง</p>
                                </button>

                            }

                        </div>

                    </div>
                    <div className="bg-white h-[100px] pt-[25px]">
                        {(couponDetail.diffStart >= 0 && couponDetail.diffExpire >= 0 && couponDetail.status === 'Active') ?
                            (
                                <Stack
                                    spacing={2}
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <SecondaryButton variant="outlined" className="w-[80%]" onClick={() => navigate(-1)}>
                                        ย้อนกลับ
                                    </SecondaryButton>
                                    {/* <SecondaryButton variant="outlined" className="w-[40%]" onClick={() => setOpenCancelPopup(true)}>
                                        ปิดใช้งานคูปอง
                                    </SecondaryButton> */}
                                </Stack>
                            ) : (couponDetail.diffStart >= 0 && couponDetail.diffExpire >= 0 && couponDetail.status === 'Inactive') ? (
                                <Stack
                                    spacing={2}
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="center"
                                >
                                    <SecondaryButton variant="outlined" className="w-[80%]" onClick={() => navigate(-1)}>
                                        ย้อนกลับ
                                    </SecondaryButton>
                                    {/* <PrimaryButton
                                        variant="outlined"
                                        className="w-[45%]"
                                        onClick={() => setOpenConfirmPopup(true)}
                                    >
                                        เปิดใช้งานคูปอง
                                    </PrimaryButton> */}
                                </Stack>
                            ) : (
                                <div className="mx-[30px]">
                                    <SecondaryButton variant="outlined" className="w-[100%]" onClick={() => navigate(-1)}>
                                        ย้อนกลับ
                                    </SecondaryButton>
                                </div>
                            )
                        }

                    </div>
                </div>}


            <CustomPopup
                title={"เปิดใช้งานคูปอง"}
                actionText={"ยืนยัน"}
                desc={
                    "คุณต้องการเปิดใช้งานคูปอง\nเพื่อให้ลูกค้าสามารถใช้งานสิทธิพิเศษนี้ได้ใช่หรือไม่"
                }
                cancelFunction={() => {
                    setOpenConfirmPopup(false);
                }}
                actionFunction={() => {
                    postUpdateCoupon();
                }}
                open={openConfirmPopup}
                onClose={() => {
                    setOpenConfirmPopup(false);
                }}
            />
            <CustomPopup
                title={"ปิดใช้งานคูปอง"}
                actionText={"ยืนยัน"}
                desc={
                    "คุณต้องการปิดใช้งานคูปองใช่หรือไม่\nลูกค้าจะไม่สามารถใช้งานคูปองนี้ได้อีก"
                }
                cancelFunction={() => {
                    setOpenCancelPopup(false);
                }}
                actionFunction={() => {
                    postUpdateCoupon();
                }}
                open={openCancelPopup}
                onClose={() => {
                    setOpenCancelPopup(false);
                }}
            />

            <Dialog open={openDeletePopup} fullWidth={true} maxWidth="xl">
                <div className="py-[24px] px-[23px] rounded-[4px]">
                    <p className="text-[24px] font-bold text-center text-red">ลบคูปอง</p>
                    <p className="text-red text-[18px] text-center whitespace-pre-line leading-[120%]">คุณต้องการลบคูปองนี้ใช่หรือไม่</p>
                    <p className="text-red text-[18px] text-center whitespace-pre-line leading-[120%]">หากลบแล้วไม่สามารถกู้คืนคูปองนี้ได้</p>

                    <div className="flex itesm-center gap-[13px] justify-center mt-[24px]">
                        <SecondaryButton
                            variant="outlined"
                            className="w-full"
                            onClick={() => setOpenDeletePopup(false)}
                        >
                            ยกเลิก
                        </SecondaryButton>
                        <PrimaryButton
                            onClick={() => {
                                postDeleteCoupon()
                            }}
                            variant="outlined"
                            className="w-full"
                        >
                            ยืนยัน
                        </PrimaryButton>

                    </div>

                </div >
            </Dialog >
        </>
    );
}
